import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {StorageService} from '@core/src/public-api';

@Injectable({
  providedIn: 'root'
})
export class LinkPatientService {
  private _showLinkPatientWarningSubject: BehaviorSubject<boolean>;
  private storageName = 'pasi-link-patient-warning';

  constructor(
    private storageService: StorageService
  ) {
    this._showLinkPatientWarningSubject = new BehaviorSubject(this.getLocalStorageItem());
  }

  getLocalStorageItem(): boolean {
    return this.storageService.getItem(this.storageName, true) === 'true';
  }

  getShowLinkPatientWarningObservable(): Observable<boolean> {
    return this._showLinkPatientWarningSubject.asObservable();
  }

  getShowLinkPatientWarning(): boolean {
    return this._showLinkPatientWarningSubject.getValue();
  }

  setShowLinkPatientWarning(showLinkPatientWarning: boolean): void {
    if (showLinkPatientWarning == null) {
      this.storageService.removeItem(this.storageName, true);
      this._showLinkPatientWarningSubject.next(showLinkPatientWarning);
      return;
    }

    this.storageService.setItem(this.storageName, showLinkPatientWarning.toString(), true);
    this._showLinkPatientWarningSubject.next(showLinkPatientWarning);
  }
}
